import React, { useContext } from "react";

import Link from "../Link";

import { generateClassString as gcs } from "../../lib/helper/generateClassString";
import { useAnchorNavStore } from "../../lib/hooks/useAnchorNav";
import translate from "../../lib/translate";

import { Headline } from "../Headline";
import { StructuredTextRenderer } from "../StructuredTextRenderer";
import { useIsDesktop } from "../../lib/hooks/mediaQueries";

import GeneralPageContext from "../../templates/GeneralPageContext";

import * as styles from "./component.module.less";

export function AnchorNavigation({ anchorNavData, anchorNavCameraData }) {
    const { currency } = useContext(GeneralPageContext);
    const [activeLinkId, setActiveLinkId] = useAnchorNavStore(
        (store) => store.active
    );

    const isSmaller1200 = useIsDesktop();

    const { name, price, priceInfoText, priceLink } = anchorNavCameraData ?? {};

    return (
        <div className={styles.anchorNavigation} data-datocms-noindex={true}>
            <div className={styles.anchorNavigationContent}>
                {name && !isSmaller1200 && (
                    <Headline
                        semanticOfHeadline="H5 Style"
                        headlineClass={styles.name}
                    >
                        {name}
                    </Headline>
                )}
                <ul>
                    {anchorNavData.map(({ link, label, translationKey }) => {
                        const linkLabel = label ?? translate(translationKey);
                        const onClick = () => {
                        };
                        return (
                            <li
                                key={`anchorLink-${link}`}
                                className={gcs([
                                    label === activeLinkId,
                                    styles.active
                                ])}
                                onClick={onClick}
                            >
                                <Link to={`#${link}`}>{linkLabel}</Link>
                            </li>
                        );
                    })}
                </ul>

                {price && !isSmaller1200 && (
                    <div className={styles.bottom}>
                        <Headline
                            semanticOfHeadline="H4 Style"
                            headlineClass={styles.price}
                        >
                            {`${price} ${currency}`}
                        </Headline>

                        <StructuredTextRenderer
                            data={priceInfoText}
                            plainLink
                            className={styles.infoText}
                        />

                        <StructuredTextRenderer
                            className={styles.button}
                            data={priceLink}
                            noContainer
                            plainLink
                            itemLinkType="cta"
                            itemLinkIconPosition={"left"}
                        />
                    </div>
                )}
            </div>
        </div>
    );
}
